import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import { ReactComponent as ClearImg } from "../../assets/icons/x.svg";
import NumKeyboard from "../NumKeyboard";

export interface NumInputProps {
    onChange: (text: string) => void;
}

const NumInput = ({onChange}: NumInputProps) => {
    const inputRef = useRef(null);
    const clearRef = useRef(null);

    const [text, setText] = useState<string>("");

    useEffect(() => {
        onChange(text);
    }, [text]);

    const onChangeTextInput = (text: string) => {
        setText(!isNaN(parseInt(text, 10)) ? parseInt(text, 10).toString() : "");
    }

    const onChangeText = (text: string) => {
        setText(!isNaN(parseInt(text, 10)) ? parseInt(text, 10).toString() : "");
    }

    return <div className="NumInput">
        <div className="inputContainer">
            <div className="input">{text}</div>
            <ClearImg ref={clearRef} className="clear" />
        </div>
        <input ref={inputRef} className="inputHide" type="text" value={text} onChange={(e) => onChangeTextInput(e.target.value)} />
        <NumKeyboard clearRef={clearRef} onChangeText={onChangeText} text={text} />
    </div>
}

export default NumInput;
